import 'cascading-drop-down-list';
import { displayValidationSummary } from 'ui-utils';
import { fetch, parseErrors } from 'utils';

onLoad();

export function onLoad(context = document) {
    // Event listener for: "Registration Search".
    context.addEventListener('registrationSearch', async e => {
        const antiForgeryToken = context.querySelector('input[name="__RequestVerificationToken"]')

        const formData = new FormData();
        formData.append('RegistrationNumberSearch.RegistrationNumber', e.detail);
        formData.append('__RequestVerificationToken', antiForgeryToken.value);

        const response = await fetch('/api/shop-models/registration-number-search', {
            method: 'POST',
            body: formData
        });

        // Get data from response.
        const data = await response.json()

        if (response.ok) {
            var vehicleRegistrationNumber = data.vehicleRegistrationNumber;
            var vehicleDescription = data.vehicleDescription;

            // Show the response element.
            var responseElement = context.getElementById('model-search-response');
            var showOnlyCompatiblePartsElement = context.getElementById("product-model-search-sidebar-compatibile-parts");

            var vueScope = responseElement.$data;
            vueScope.vehicleRegistrationNumber = vehicleRegistrationNumber;
            vueScope.vehicleDescription = vehicleDescription;
            
            // Hide forms.
            var form = context.getElementById('product-model-search-forms')
            form.classList.add('d-none');

            // Show response.
            responseElement.classList.remove('d-none');
            showOnlyCompatiblePartsElement.classList.remove('d-none');

            document.getElementById('product-listings').$data.find();
        }
        else {
             // Get the errors.
             const errors = parseErrors(data);

             // Display the validation summary.
             displayValidationSummary(context.getElementById('registration-number-search'), errors);
        }
    })

    // Event listener for: "Model Search".
    context.addEventListener('modelSearch', async e => {
        const antiForgeryToken = context.querySelector('input[name="__RequestVerificationToken"]')

        const formData = new FormData();
        formData.append('ModelNumberSearch.ManufacturerId', e.detail.manufacturerId);
        formData.append('ModelNumberSearch.ModelId', e.detail.modelId);
        formData.append('ModelNumberSearch.FuelTypeId', e.detail.fuelTypeId);
        formData.append('ModelNumberSearch.YearId', e.detail.yearId);
        formData.append('ModelNumberSearch.VersionId', e.detail.versionId);

        formData.append('__RequestVerificationToken', antiForgeryToken.value);

        const response = await fetch('/api/shop-models/model-number-search', {
            method: 'POST',
            body: formData
        });

        const data = await response.json()

        if (response.ok) {
             // Get data from the event detail.
            var vehicleDescription = data.vehicleDescription;

            // Get the response elements.
            var responseElement = context.getElementById('model-search-response');
            var showOnlyCompatiblePartsElement = context.getElementById("product-model-search-sidebar-compatibile-parts");

            var vueScope = responseElement.$data;
            vueScope.vehicleDescription = vehicleDescription;

            // Hide forms.
            var form = context.getElementById('product-model-search-forms')
            form.classList.add('d-none');

            // Show response.
            responseElement.classList.remove('d-none');
            showOnlyCompatiblePartsElement.classList.remove('d-none');

            document.getElementById('product-listings').$data.find();
        }
        else {
             // Get the errors.
             const errors = parseErrors(data);

             // Display the validation summary.
             displayValidationSummary(context.getElementById('model-search'), errors);
        }
    })

    // Event listener for: "Show Only Compatible Parts".
    context.addEventListener('change', async (e) => {
        if (e.target.id !== 'show-only-compatible-parts')
            return;

        const compatiblePartsCheckbox = context.getElementById('show-only-compatible-parts');

        // disable to prevent double-triggering.
        compatiblePartsCheckbox.disabled = true;

        const response = await fetch('/api/shop-models/toggle-show-only-compatible-parts', {
            method: 'GET'
        });

        if (response.ok)
            window.location.reload();
    });
}